<template>
  <section class="hero-artisans container-fluid px-0">
    <div class="row g-0 flex-lg-row flex-column">
      <!-- Col gauche : à qui on s’adresse (fond vert) -->
      <div
        class="col-12 col-lg-6 px-5 py-5 d-flex align-items-center hero-left"
      >
        <div class="content">
          <p class="badge">ESPACE ARTISANS</p>
          <h1 class="title">
            Vous êtes artisan<br />
            ou entreprise du <span class="highlight">BTP&nbsp;?</span>
          </h1>
          <p class="description">
            Entreprises générales, corps d’état spécialisés, TPE du bâtiment,
            <strong>artisans</strong> indépendants&nbsp;: si vos équipes passent
            encore du temps à «&nbsp;courir au dépôt&nbsp;» pour chercher du
            matériel, Livratos est fait pour vous.
          </p>
          <p class="description">
            La plateforme devient votre relais logistique pour
            <strong>faire livrer le matériel directement sur chantier</strong>,
            garder vos équipes en production et reprendre la main sur vos coûts
            de <strong>livraison</strong>.
          </p>
        </div>
      </div>

      <!-- Col droite : pourquoi utiliser Livratos (fond noir) -->
      <div
        class="col-12 col-lg-6 px-5 py-5 d-flex align-items-center hero-right"
      >
        <div class="content">
          <h2 class="subtitle">
            Pourquoi utiliser <span class="accent">Livratos</span>&nbsp;?
          </h2>
          <p class="description">
            Livratos connecte vos <strong>chantiers</strong>, vos
            <strong>fournisseurs</strong> et un réseau de
            <strong>livreurs indépendants</strong>, pour que le matériel arrive
            là où il sert, sans immobiliser un compagnon sur la route.
          </p>

          <ul class="hero-benefits">
            <li>
              <strong>Plus personne à retirer du chantier</strong>&nbsp;: vous
              faites <strong>livrer</strong> au lieu d’envoyer un véhicule.
            </li>
            <li>
              <strong>Moins de temps perdu</strong>&nbsp;dans les bouchons, les
              files d’attente dépôt et les allers-retours inutiles.
            </li>
            <li>
              <strong>Véhicule adapté</strong> à chaque besoin&nbsp;: utilitaire
              léger, fourgon, plateau, poids lourd…
            </li>
            <li>
              <strong>Visibilité sur vos coûts logistiques</strong>&nbsp;:
              <strong>livraisons</strong> regroupées et traçabilité par
              <strong>chantier</strong>.
            </li>
          </ul>

          <div class="d-flex gap-3 mt-4 flex-wrap">
            <a href="https://www.livratos.app" class="btn btn-cta fw-semibold">
              Créer mon compte artisan
            </a>
            <a
              href="/contact"
              class="btn btn-link text-decoration-none fw-medium link-more"
            >
              Parler à l’équipe Livratos
            </a>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "HeroArtisans",
};
</script>

<style lang="scss" scoped>
.hero-artisans {
  margin-top: 72px;
  margin-bottom: 72px;

  .content {
    max-width: 540px;
    margin: auto;
  }

  /* === Mobile / par défaut : blocs empilés vert puis noir === */
  .hero-left {
    background-color: $color-primary;
    color: #ffffff;

    .badge {
      display: inline-block;
      background-color: rgba(#000000, 0.16);
      color: #000;
      font-size: 0.7rem;
      font-weight: 600;
      padding: 0.3rem 0.9rem;
      border-radius: 50px;
      text-transform: uppercase;
      letter-spacing: 1px;
    }

    .title {
      font-size: 2.2rem;
      font-weight: 700;
      color: #ffffff;
      margin-top: 1rem;
      line-height: 1.3;

      .highlight {
        color: #000000;
      }

      @media (min-width: 768px) {
        font-size: 3rem;
      }
    }

    .description {
      color: rgba(#ffffff, 0.92);
      margin-top: 1.1rem;
      font-size: 1rem;
      line-height: 1.7;

      @media (min-width: 768px) {
        font-size: 1.05rem;
      }
    }
  }

  .hero-right {
    background-color: #000000;
    color: #ffffff;

    .subtitle {
      font-size: 1.7rem;
      font-weight: 700;
      color: #ffffff;
      margin-bottom: 0.75rem;

      .accent {
        color: $color-primary;
      }

      @media (min-width: 768px) {
        font-size: 2rem;
      }
    }

    .description {
      color: rgba(#ffffff, 0.9);
      margin-top: 0.8rem;
      font-size: 1rem;
      line-height: 1.7;

      @media (min-width: 768px) {
        font-size: 1.05rem;
      }
    }

    .hero-benefits {
      margin-top: 1rem;
      padding-left: 0;
      list-style: none;

      li {
        position: relative;
        padding-left: 1.3rem;
        margin-bottom: 0.45rem;
        font-size: 0.95rem;
        color: rgba(#ffffff, 0.9);

        &::before {
          content: "";
          position: absolute;
          left: 0;
          top: 0.55em;
          width: 7px;
          height: 7px;
          border-radius: 50%;
          background-color: $color-primary;
          box-shadow: 0 0 0 2px rgba($color-primary, 0.25);
          transform: translateY(-50%);
        }
      }
    }

    .btn-cta {
      background-color: $color-primary;
      border: 1px solid $color-primary;
      color: #000;
      padding: 0.65rem 1.6rem;
      border-radius: 6px;
      font-size: 0.95rem;
      text-transform: uppercase;

      &:hover {
        background-color: darken($color-primary, 8%);
        border-color: darken($color-primary, 8%);
        color: #000;
      }
    }

    .link-more {
      color: #ffffff;
      font-size: 0.95rem;

      &:hover {
        color: $color-primary;
        text-decoration: underline;
      }
    }
  }

  /* === Desktop : diagonale noir/vert comme pour fournisseurs === */
  @media (min-width: 992px) {
    position: relative;
    overflow: hidden;
    background-color: $color-primary;

    .hero-left {
      background-color: transparent;
    }

    .hero-right {
      background-color: transparent;
    }

    &::before {
      content: "";
      position: absolute;
      top: 0;
      right: -10%;
      bottom: 0;
      width: 60%;
      background-color: #000000;
      transform: skewX(-10deg);
      transform-origin: top right;
      z-index: 0;
    }

    .hero-left,
    .hero-right {
      position: relative;
      z-index: 1;
    }
  }
}
</style>
